import React from "react";
import { observer } from "mobx-react";
import { OrbitComponent } from "../../base-components/orbit-component/orbit-component";
import { Button } from "../../../basic-ui-components/button/base/button.component";
import {Label} from "../boxes/label";
import {SetTimeoutType} from "../../../../common/types/set-timeout-type";
import {PixiSpineAnimation} from "../../../services/pixi-app/pixi-spine-animation";
import {ShowcaseConfigurationBox} from "../boxes/showcase-configuration/showcase-configuration.box";
import {ShowcaseContentContainerBox} from "../boxes/showcase-content-container/showcase-content-container.box";


type PixiAppDestroyerFn = () => void;
interface IAnimationDef {
    label: string;
    spineJsonUrl: string;
    width: number;
    height: number;
};

export const PixiSpineShowcase = observer(class PixiSpineShowcase extends OrbitComponent {

    private _forceCanvas = false;
    private _runAnimationASAP = true;
    private _animationIndex = 0;
    private _animationList: IAnimationDef[] = [{
        spineJsonUrl: this.services.theme.currentTheme.images.animatedIconsPOC.millionaireGenieMegawaysSpineV1.toString(),
        label: "Genie Megaways, Small, open setup pose with some artifacts (v1)",
        width: 190, height: 191
    }, {
        spineJsonUrl: this.services.theme.currentTheme.images.animatedIconsPOC.millionaireGenieMegawaysSpineV2.toString(),
        label: "Genie Megaways, Big, open setup pose",
        width: 210, height: 290
    }, {
        spineJsonUrl: this.services.theme.currentTheme.images.animatedIconsPOC.millionaireGenieMegawaysSpineV3.toString(),
        label: "Genie Megaways, Small, open setup pose with some artifacts (v2)",
        width: 190, height: 191
    }, {
        spineJsonUrl: this.services.theme.currentTheme.images.animatedIconsPOC.millionaireGenieMegawaysSpineV4.toString(),
        label: "Genie Megaways, Small, closed setup pose, wrong origin",
        width: 190, height: 191
    }];

    private _pixiAppDestroyers: PixiAppDestroyerFn[] = [];

    private addPixiAnimation = async (def: IAnimationDef) => {
        if (!this._pixiAppRootEl) {
            return;
        }
        let iconPixiAnimation = new PixiSpineAnimation(this.services, {
            width: def.width, height: def.height, force2DCanvasContext: !!this._forceCanvas
        }, [{name: 'burnoutAnimationResource', jsonUrl: def.spineJsonUrl}], {
            render: ({spineAnimations, loaderResources}) => {
                const spineAnimation = spineAnimations.burnoutAnimationResource;
                // get the animations
                const availableAnimations = loaderResources.burnoutAnimationResource.spineData.animations.map(a => a.name);

                // set the position and scale
                // spineAnimation.x = app.screen.width / 2;
                // spineAnimation.y = app.screen.height;
                // spineAnimation.scale.set(0.5);

                // play animation
                const runAnimation = () => {
                    /* let spineAnimationTrackEntry = */spineAnimation.state.setAnimation(0, availableAnimations[0], false);
                    // spineAnimationTrackEntry.timeScale = 0.25;
                    // spineAnimationTrackEntry.listener = {
                    //     event: (entry, event) => {
                    //         console.log('TRACK ENTRY event', event, 'entry', entry);
                    //         if (event.stringValue === "event name") { do stuff here... }
                    //     },
                    //     complete: (entry) => { console.log("TRACK ENTRY COMPLETE", entry); },
                    //     start: (entry) => { console.log('TRACK ENTRY start ', entry); }, <-- this cannot be trusted. It doesn't fire for the first animation in a track and for any animation set with "setAnimation"
                    //     end: (entry) => { console.log('TRACK ENTRY ended', entry); },
                    //     dispose: (entry) => { console.log('TRACK ENTRY disposed', entry); },
                    //     interrupt: (entry) => { console.log('TRACK ENTRY interrupted ', entry); }
                    // };
                }
                let animationSchedule: SetTimeoutType;

                spineAnimation.state.addListener({
                    // event: (entry, event) => {
                    //     console.log('ANIMATION event', event, 'entry', entry);
                    //     if (event.stringValue === "event name") { do stuff here... }
                    // },
                    complete: (entry) => {
                        // when animation completes, schedule the next iteration
                        animationSchedule = setTimeout(runAnimation, 2000);
                    },
                    // start: (entry) => { console.log('ANIMATION start ', entry); },
                    // end: (entry) => { console.log('ANIMATION ended', entry); },
                    // dispose: (entry) => { console.log('ANIMATION disposed', entry); },
                    // interrupt: (entry) => { console.log('ANIMATION interrupted ', entry); }
                });

                if (this._runAnimationASAP) {
                    runAnimation();
                } else {
                    animationSchedule = setTimeout(runAnimation, 2000);
                }

                this._pixiAppDestroyers.push(iconPixiAnimation.dispose);

                return () => {
                    clearTimeout(animationSchedule);
                    animationSchedule = undefined;
                };
            }
        });

        iconPixiAnimation.start();
        iconPixiAnimation.attachToDOM(this._pixiAppRootEl);
    };

    private removePixiAnimation = (oldest: boolean = true) => {
        let appDestroyer = oldest ? this._pixiAppDestroyers.shift() : this._pixiAppDestroyers.pop();
        if (appDestroyer) {
            appDestroyer();
            appDestroyer = undefined;
        }
    };
    private _pixiAppRootEl: HTMLDivElement | null = null;
    private capturePixiAppRootEl = (el: HTMLDivElement | null) => {
        this._pixiAppRootEl = el;
    };
    render() {
        return <>
            <ShowcaseContentContainerBox>
                <ShowcaseConfigurationBox>
                    <div>
                        <input
                            type="checkbox" name="forceCanvas" id="forceCanvas" value="forceCanvas"
                            onChange={(e) => { this._forceCanvas = e.target.checked; }} defaultChecked={this._forceCanvas}
                        />
                        <Label htmlFor={"forceCanvas"}>Force 2D canvas</Label>
                    </div>
                    <div>
                        <input
                            type="checkbox" name="runAnimationASAP" id="runAnimationASAP" value="runAnimationASAP"
                            onChange={(e) => { this._runAnimationASAP = e.target.checked; }} defaultChecked={this._runAnimationASAP}
                        />
                        <Label htmlFor={"runAnimationASAP"}>Run Animation ASAP</Label>
                    </div>
                </ShowcaseConfigurationBox>
                <ShowcaseConfigurationBox>
                    <div>{ this._animationList.map((animationDef, i) =>
                        <div key={"animation_def_" + i}>
                            <input
                                type="radio" name="animation_def" id={"animation_def_" + i} value={i} defaultChecked={i === this._animationIndex}
                                onChange={() => { this._animationIndex = i; }}
                            />
                            <Label htmlFor={"animation_def_" + i}>{animationDef.label}</Label>
                        </div>
                    ) }</div>
                </ShowcaseConfigurationBox>
            </ShowcaseContentContainerBox>
            <ShowcaseContentContainerBox>
                <Button preset="primary" onClick={() => {
                    this.addPixiAnimation(this._animationList[this._animationIndex]);
                }}>Add Pixi Animated Game Icon</Button>
                <Button preset="info" onClick={this.removePixiAnimation}>Remove oldest</Button>
                <Button preset="info" onClick={() => { this.removePixiAnimation(false); }}>Remove newest</Button>
            </ShowcaseContentContainerBox>
            <div ref={this.capturePixiAppRootEl}></div>

            {/* <iframe src="https://localhost:7070/laboratory" style={{width: "100%", height: 800}}></iframe> */}
        </>;
    }
});
